import { useMutation, useQuery } from '@tanstack/react-query'
import { addReportReasonCategory, updateReportReasonCategory, updateReportReasonCategoryStatus, deleteReportReasonCategory, getReportReasonCategories, createReportReason, updateReportReason, updateReportReasonStatus, deleteReportReason, getReportReasons } from '../api/reportReasons'

// Report Reason Category
export const useGetReportReasonCategories = (queryParams = '') => {
    return useQuery({
        queryKey: ['report_reason_categories', queryParams],
        queryFn: () => getReportReasonCategories(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateReportReasonCategory = () => {
    return useMutation({
        mutationFn: addReportReasonCategory
    })
};

export const useUpdateReportReasonCategory = () => {
    return useMutation({
        mutationFn: updateReportReasonCategory
    })
};

export const useUpdateReportReasonCategoryStatus = () => {
    return useMutation({
        mutationFn: updateReportReasonCategoryStatus
    })
};

export const useDeleteReportReasonCategory = () => {
    return useMutation({
        mutationFn: deleteReportReasonCategory
    })
};

// Report Reason
export const useGetReportReasons = (queryParams = '') => {
    return useQuery({
        queryKey: ['report_reasons', queryParams],
        queryFn: () => getReportReasons(queryParams),
        enabled: !!queryParams
    });
};

export const useCreateReportReason = () => {
    return useMutation({
        mutationFn: createReportReason
    })
};

export const useUpdateReportReason = () => {
    return useMutation({
        mutationFn: updateReportReason
    })
};

export const useUpdateReportReasonStatus = () => {
    return useMutation({
        mutationFn: updateReportReasonStatus
    })
};

export const useDeleteReportReason = () => {
    return useMutation({
        mutationFn: deleteReportReason
    })
};